export const formatStripePrice = (price: number) => {
  let formatedPricing = price / 100;

  return formatedPricing.toLocaleString("fr-FR", {
    style: "currency",
    currency: "EUR",
  });
};
